import React, {useState} from "react";
import { FormGroup, Label, Input, FormFeedback, InputGroup, InputGroupAddon, Button } from "reactstrap";

import styles from "./File.module.scss";

export default props => {
  const [fileName, setFileName] = useState();
  const { input:{value, ...restInput}, label, id, meta: { error, touched }, ...rest } = props;
  const handleFileSelect=e=>{
     var file = e.target.files[0]; // FileList object
      if(file){
        setFileName(file.name)
        props.input.onChange({file})
        // Reads the base64 of image to preview
        const previewReader = new FileReader();
  
        previewReader.onload = () => {
          const img = new Image();
          const src = previewReader.result;
          img.onload = () => {
            props.input.onChange({file, src})
          };
          img.src = src;
        };
  
        previewReader.readAsDataURL(file);
      }


  }
  return (
    <FormGroup>
      {label && <Label htmlFor={id}>{label}</Label>}
      <InputGroup className="position-relative overflow-hidden">
        <Input placeholder={fileName} disabled />
        <Input id={id} {...restInput} {...rest} onChange={handleFileSelect} className={styles.file} />
        <InputGroupAddon addonType="append">
          <Button type="button">انتخاب فایل </Button>
        </InputGroupAddon>
      </InputGroup>
      <Input type="hidden" invalid={error && touched} />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  )
}